import { render, staticRenderFns } from "./LogisticInfo.vue?vue&type=template&id=d7095a90&scoped=true"
import script from "./LogisticInfo.vue?vue&type=script&lang=js"
export * from "./LogisticInfo.vue?vue&type=script&lang=js"
import style0 from "./LogisticInfo.vue?vue&type=style&index=0&id=d7095a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7095a90",
  null
  
)

export default component.exports